import { useState } from "react";
import CustomButton from "../../../common/CustomButton";
import TextOptionTile from "../../../common/TextOptionTile";


function SlideSelectWorkoutLength(props) {
    const wl = [
        "15 mins - 30 mins",
        "30 mins - 45 mins",
        "45 mins - 60 mins",
        "60 mins - 75 mins",
        "75+ mins",
    ];
    const [selectedWL, setSelectedWL] = useState("");

    const updateOptions = (m) => {
        setSelectedWL(m)
    }


    let disable = selectedWL === "";

    return (
        <div id="uo-select-workout-length" className="uo-component">
            <div id="uo-wl-form" className="ou-with-text">
                <h4>What length do you prefer for your exercise sessions?</h4>

                <div id="uo-wl-f-minutes">
                    {
                        wl.map((w, index) => {
                            return <TextOptionTile key={index} label={w} onClick={updateOptions} isActive={selectedWL == w} />
                        })
                    }
                </div>

                <CustomButton disabled={disable} className="uo-button active" onClick={() => {
                    props?.moveNext();
                    props?.setPreRegistrationDetails(prd => ({
                        ...prd,
                        preferedWorkoutLength: selectedWL
                    }));
                }}>Continue</CustomButton>
            </div>
        </div>
    );
}

export default SlideSelectWorkoutLength;